export const SUPPORT_CATEGORY_ID = {
  inRestaurantSurveys: 'c673bd7e-0596-44ba-bc66-3faae676b8ed',
  inRestaurantIssues: 'b100fac7-73b5-4b40-b738-86c04e9c6081',
};
